import { Routes, Route, useNavigate } from "react-router-dom";
import { useState, useEffect } from "@wordpress/element";
import { styled } from "@mui/material/styles";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Toolbar from "@mui/material/Toolbar";
import CartContainer from "./CartContainer";
import Account, { LoginPage, SignupPage } from "vino/components/Account";

const StyledSwipeableDrawer = styled(SwipeableDrawer)(({ theme }) => ({
	"& .MuiDrawer-paper": {
		backgroundColor: theme.palette.background.default,
		width: 500,
	},
}));

const routes = {
	cart: "cart",
	login: "login",
	signup: "signup",
};

const titles = {
	cart: "My Cart",
	login: "Login",
	signup: "Signup",
};

const QuickCartPanel = ({ open, onClose }) => {
	const navigate = useNavigate();
	const [route, setRoute] = useState(routes.cart);

	useEffect(() => {
		if (open) {
			navigate("/");
		}
	}, [open]);

	const handleCheckout = () => {
		setRoute(routes.login);
	};

	return (
		<StyledSwipeableDrawer
			anchor="right"
			open={open}
			disableSwipeToOpen
			onOpen={() => {}}
			onClose={onClose}
		>
			<div position="static" className="shadow-md">
				<Toolbar className="px-4">
					<div className="flex flex-1 items-center px-12">
						<Typography className="mx-16 text-16" color="inherit">
							{titles[route]}
						</Typography>
					</div>
					<div className="flex px-4">
						<IconButton onClick={onClose} color="inherit">
							<Icon className="fa-solid fa-xmark" />
						</IconButton>
					</div>
				</Toolbar>
			</div>
			<div className="flex flex-col">
				<Routes>
					<Route
						path="/"
						element={<CartContainer onClick={handleCheckout} />}
					/>
					<Route path="/account" element={<Account />}>
						<Route path="login" element={<LoginPage />} />
						<Route path="signup" element={<SignupPage />} />
					</Route>
				</Routes>
			</div>
		</StyledSwipeableDrawer>
	);
};

export default QuickCartPanel;
